export default "__VITE_ASSET__Dbq9adNc__"